import { render, staticRenderFns } from "./application-confirm.vue?vue&type=template&id=5dc9a126&scoped=true&"
import script from "./application-confirm.vue?vue&type=script&lang=js&"
export * from "./application-confirm.vue?vue&type=script&lang=js&"
import style0 from "./application-confirm.vue?vue&type=style&index=0&id=5dc9a126&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9a126",
  null
  
)

export default component.exports